module.exports = __webpack_public_path__ + "static/img/video_5.a0b0a2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_5.jpg
// module id = YAj+
// module chunks = 1